import { FLEET_VEHICLE_STATUS_DETAIL_FIELDS } from "services/api/fleet/vehicles/consts";
import {
  FleetVehicleStatusDetailField,
  FleetVehicleStatusDetailFieldConfig,
  FleetVehicleStatusEnum,
} from "services/api/fleet/vehicles/types";

/**
 * Konfiguracija jednog polja za zadani status, ili undefined ako ga status ne traži.
 *
 * Komponente po statusu crtaju polja, ali naslove i obaveznost i dalje čitaju odavde —
 * iz iste konstante iz koje se gradi Yup shema. Bez toga bi se prikaz i validacija
 * mogli razići, a obaveznost više ne bi odgovarala `VehicleStatusDetailValidator` na backendu.
 */
export const getStatusField = (
  status: FleetVehicleStatusEnum,
  field: FleetVehicleStatusDetailField
): FleetVehicleStatusDetailFieldConfig | undefined =>
  FLEET_VEHICLE_STATUS_DETAIL_FIELDS[status]?.find((config) => config.field === field);
